/* tslint:disable */
/* eslint-disable */
/**
 * Contract Management API
 * API for managing contracts
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IdLabel } from './IdLabel';
import {
    IdLabelFromJSON,
    IdLabelFromJSONTyped,
    IdLabelToJSON,
    IdLabelToJSONTyped,
} from './IdLabel';
import type { InsuredInfo } from './InsuredInfo';
import {
    InsuredInfoFromJSON,
    InsuredInfoFromJSONTyped,
    InsuredInfoToJSON,
    InsuredInfoToJSONTyped,
} from './InsuredInfo';
import type { ContractType } from './ContractType';
import {
    ContractTypeFromJSON,
    ContractTypeFromJSONTyped,
    ContractTypeToJSON,
    ContractTypeToJSONTyped,
} from './ContractType';
import type { GenericColors } from './GenericColors';
import {
    GenericColorsFromJSON,
    GenericColorsFromJSONTyped,
    GenericColorsToJSON,
    GenericColorsToJSONTyped,
} from './GenericColors';

/**
 * 
 * @export
 * @interface ContractDetailsGlobal
 */
export interface ContractDetailsGlobal {
    /**
     * Type de quittance, déjà libellé par le back : « Comptant », « Terme », « Sinistre » ou « Résiliation ». Chaîne prête à afficher, aucun code à traduire — un contrat nouvellement souscrit est toujours en « Comptant ».
     * @type {string}
     * @memberof ContractDetailsGlobal
     */
    receiptType?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ContractDetailsGlobal
     */
    riskId: string;
    /**
     * 
     * @type {ContractType}
     * @memberof ContractDetailsGlobal
     */
    contractType: ContractType;
    /**
     * 
     * @type {string}
     * @memberof ContractDetailsGlobal
     */
    contractIdentifier: string;
    /**
     * 
     * @type {IdLabel}
     * @memberof ContractDetailsGlobal
     */
    groupContract?: IdLabel;
    /**
     * 
     * @type {InsuredInfo}
     * @memberof ContractDetailsGlobal
     */
    insured: InsuredInfo;
    /**
     * 
     * @type {string}
     * @memberof ContractDetailsGlobal
     */
    status: string;
    /**
     * 
     * @type {GenericColors}
     * @memberof ContractDetailsGlobal
     */
    statusColor?: GenericColors;
    /**
     * 
     * @type {string}
     * @memberof ContractDetailsGlobal
     */
    branchCode: string;
    /**
     * 
     * @type {string}
     * @memberof ContractDetailsGlobal
     */
    productOwner: string;
    /**
     * 
     * @type {Date}
     * @memberof ContractDetailsGlobal
     */
    startDate: Date;
    /**
     * 
     * @type {Date}
     * @memberof ContractDetailsGlobal
     */
    creationDate: Date;
    /**
     * 
     * @type {string}
     * @memberof ContractDetailsGlobal
     */
    mainDueDate: string;
    /**
     * 
     * @type {string}
     * @memberof ContractDetailsGlobal
     */
    paymentFrequency: string;
    /**
     * Who is billed for this contract, ready-to-display label from the back: « Souscripteur » (default), « Courtier » (collecting broker) or « Souscripteur collectif » (member contract paid by the group subscriber).
     * @type {string}
     * @memberof ContractDetailsGlobal
     */
    billedBy?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ContractDetailsGlobal
     */
    cancellationNotice: string;
    /**
     * 
     * @type {string}
     * @memberof ContractDetailsGlobal
     */
    productLabel: string;
    /**
     * 
     * @type {string}
     * @memberof ContractDetailsGlobal
     */
    groupContractOwner?: string;
    /**
     * 
     * @type {number}
     * @memberof ContractDetailsGlobal
     */
    clientPrice: number;
    /**
     * 
     * @type {number}
     * @memberof ContractDetailsGlobal
     */
    unreadHistoryCount?: number;
    /**
     * 
     * @type {string}
     * @memberof ContractDetailsGlobal
     */
    borrowerProjectId?: string;
}



/**
 * Check if a given object implements the ContractDetailsGlobal interface.
 */
export function instanceOfContractDetailsGlobal(value: object): value is ContractDetailsGlobal {
    if (!('riskId' in value) || value['riskId'] === undefined) return false;
    if (!('contractType' in value) || value['contractType'] === undefined) return false;
    if (!('contractIdentifier' in value) || value['contractIdentifier'] === undefined) return false;
    if (!('insured' in value) || value['insured'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('branchCode' in value) || value['branchCode'] === undefined) return false;
    if (!('productOwner' in value) || value['productOwner'] === undefined) return false;
    if (!('startDate' in value) || value['startDate'] === undefined) return false;
    if (!('creationDate' in value) || value['creationDate'] === undefined) return false;
    if (!('mainDueDate' in value) || value['mainDueDate'] === undefined) return false;
    if (!('paymentFrequency' in value) || value['paymentFrequency'] === undefined) return false;
    if (!('cancellationNotice' in value) || value['cancellationNotice'] === undefined) return false;
    if (!('productLabel' in value) || value['productLabel'] === undefined) return false;
    if (!('clientPrice' in value) || value['clientPrice'] === undefined) return false;
    return true;
}

export function ContractDetailsGlobalFromJSON(json: any): ContractDetailsGlobal {
    return ContractDetailsGlobalFromJSONTyped(json, false);
}

export function ContractDetailsGlobalFromJSONTyped(json: any, ignoreDiscriminator: boolean): ContractDetailsGlobal {
    if (json == null) {
        return json;
    }
    return {
        
        'receiptType': json['receiptType'] == null ? undefined : json['receiptType'],
        'riskId': json['riskId'],
        'contractType': ContractTypeFromJSON(json['contractType']),
        'contractIdentifier': json['contractIdentifier'],
        'groupContract': json['groupContract'] == null ? undefined : IdLabelFromJSON(json['groupContract']),
        'insured': InsuredInfoFromJSON(json['insured']),
        'status': json['status'],
        'statusColor': json['statusColor'] == null ? undefined : GenericColorsFromJSON(json['statusColor']),
        'branchCode': json['branchCode'],
        'productOwner': json['productOwner'],
        'startDate': (new Date(json['startDate'])),
        'creationDate': (new Date(json['creationDate'])),
        'mainDueDate': json['mainDueDate'],
        'paymentFrequency': json['paymentFrequency'],
        'billedBy': json['billedBy'] == null ? undefined : json['billedBy'],
        'cancellationNotice': json['cancellationNotice'],
        'productLabel': json['productLabel'],
        'groupContractOwner': json['groupContractOwner'] == null ? undefined : json['groupContractOwner'],
        'clientPrice': json['clientPrice'],
        'unreadHistoryCount': json['unreadHistoryCount'] == null ? undefined : json['unreadHistoryCount'],
        'borrowerProjectId': json['borrowerProjectId'] == null ? undefined : json['borrowerProjectId'],
    };
}

export function ContractDetailsGlobalToJSON(json: any): ContractDetailsGlobal {
    return ContractDetailsGlobalToJSONTyped(json, false);
}

export function ContractDetailsGlobalToJSONTyped(value?: ContractDetailsGlobal | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'receiptType': value['receiptType'],
        'riskId': value['riskId'],
        'contractType': ContractTypeToJSON(value['contractType']),
        'contractIdentifier': value['contractIdentifier'],
        'groupContract': IdLabelToJSON(value['groupContract']),
        'insured': InsuredInfoToJSON(value['insured']),
        'status': value['status'],
        'statusColor': GenericColorsToJSON(value['statusColor']),
        'branchCode': value['branchCode'],
        'productOwner': value['productOwner'],
        'startDate': ((value['startDate']).toISOString().substring(0,10)),
        'creationDate': ((value['creationDate']).toISOString().substring(0,10)),
        'mainDueDate': value['mainDueDate'],
        'paymentFrequency': value['paymentFrequency'],
        'billedBy': value['billedBy'],
        'cancellationNotice': value['cancellationNotice'],
        'productLabel': value['productLabel'],
        'groupContractOwner': value['groupContractOwner'],
        'clientPrice': value['clientPrice'],
        'unreadHistoryCount': value['unreadHistoryCount'],
        'borrowerProjectId': value['borrowerProjectId'],
    };
}

